/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreLazyModule, LAZY_SYMBOLS, lazyActivatorRoute } from '@gh/core-lazy';

import { graphicalTakeOffMainDialogRoute } from './components/main';

const routes = [lazyActivatorRoute];

export function gtoLazySymbolsFactory(): Hash<any> {
  return { graphicalTakeOffMainDialogRoute };
}

@NgModule({
  imports: [
    CoreLazyModule.forChild(),
    RouterModule.forChild(routes),
  ],
  providers: [
    { provide: LAZY_SYMBOLS, useFactory: gtoLazySymbolsFactory, deps: [] },
  ],
})
export class BuilderGtoRoutingModule {
}
